// extracted by mini-css-extract-plugin
export var active = "_2p-d";
export var blink = "_2p-e";
export var container = "_2p-5";
export var controls = "_2p-0";
export var controlsRight = "_2p-1";
export var fakeCursor = "_2p-c";
export var hidden = "_2p-b";
export var quillContainerSmall = "_2p-7";
export var quillEditor = "_2p-6";
export var quillEditorSmall = "_2p-8";
export var quillFormatButtons = "_2p-a";
export var quillToolbar = "_2p-9";
export var removePadding = "_2p-2";
export var state = "_2p-3";
export var stateTitle = "_2p-4";